import {createAsyncThunk} from '@reduxjs/toolkit';
import {AppThunkApiConfig} from '../../createStore';
import {mapiqApi, ActivityType, DeskAmenity} from '@lib/infrastructure';

export const getAvailableDeskAmenitiesForBuilding = createAsyncThunk<
  DeskAmenity[],
  {buildingId: string},
  AppThunkApiConfig
>('typology/getAvailableDeskAmenitiesForBuilding', async ({buildingId}, {extra}) => {
  const client = extra.apiClient;
  const api = mapiqApi(client);

  return await api.getAvailableDeskAmenitiesForBuilding({buildingId}).then((data) => {
    return data.sort();
  });
});

export const getAvailableActivityTypesForBuilding = createAsyncThunk<
  ActivityType[],
  {buildingId: string},
  AppThunkApiConfig
>('typology/getAvailableActivityTypesForBuilding', async ({buildingId}, {extra}) => {
  const client = extra.apiClient;
  const api = mapiqApi(client);

  return await api.getAvailableActivityTypesForBuilding({buildingId}).then((data) => {
    return data.sort();
  });
});
